module.exports = __webpack_public_path__ + "media/Alert 2.0536738d.mp3";